module.exports = __webpack_public_path__ + "static/media/620375.57acc56c.svg";